/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const MESSAGES = {
  NO_APPLICATION: "No Application To Display",
  DELETE_APPLICATION_TITLE: "Are you sure you want to delete the Application ",
};

const TITLES = {
  SEARCH: "Search",
  NO_ITEMS_FOUND: "No Items Found",
};

export const PAGE_SIZE_CUSTOMERS = 10;

export { MESSAGES, TITLES };
